module.exports = __webpack_public_path__ + "img/darts.25d35aef.svg";